module.exports = __webpack_public_path__ + "static/media/doc11.7e72afa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/doc11.png
// module id = 63
// module chunks = 0